
import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface ShareState {
    showPendingOrderPopup: boolean;
    orderDetailsList?:any;
    paymentUrl?:string;
}
const rawState: ShareState = {
    showPendingOrderPopup: false,
};

const intialState = fromJS(rawState);

export default function PendingOrderReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SHOW_PENDING_ORDER_POPUP:
            return merge(state, fromJS({ showPendingOrderPopup: true}));
        case Actions.HIDE_PENDING_ORDER_POPUP:
            return merge(state, fromJS({ showPendingOrderPopup: false }));
        case Actions.SET_ORDER_DETAILS_LIST:
            return merge(state, fromJS({ orderDetailsList: action.payload }));
        case Actions.SET_PAYMENT_URL:
            return merge(state, fromJS({ paymentUrl: action.payload }));
        default:
            return state;
    }
}

